import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

export default function PasswordResultDialog({
  open,
  password,
  onClose,
}) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password || "");
      global.showPopup("Kopyalandı", "Şifre panoya kopyalandı.");
    } catch (error) {
      global.showPopup("Hata", "Şifre kopyalanamadı.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Oluşturulan Şifre</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Bu şifre sadece bir kez gösterilir. Kopyalayıp güvenli şekilde paylaşın.
        </Typography>
        <TextField fullWidth value={password || ""} InputProps={{ readOnly: true }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Kapat</Button>
        <Button variant="contained" onClick={handleCopy}>
          Kopyala
        </Button>
      </DialogActions>
    </Dialog>
  );
}
